import React from "react";
import { Helmet } from "react-helmet-async";
import { CONFIG } from "../config";

export default function SEO({ 
  title, 
  description, 
  keywords, 
  url, 
  ogImage,
  ogType = "website",
  canonical,
  schema // Optional JSON-LD object
}) {
  // Dynamic site URL for environment isolation (Dev / Staging / Prod)
  const siteUrl = CONFIG.SITE_URL;
  const defaultTitle = "Antaryatra – A Safe Space to Talk, Reflect & Find Clarity";
  const defaultDesc = "Antaryatra is a safe space to talk, reflect, and find clarity. Connect with real listeners, explore your inner journey, and navigate life with calm support — without pressure or judgment.";
  const defaultKeywords = "empathy, listening, reflection, mental well-being, antaryatra, sanctuary";
  const defaultImage = `${siteUrl}/antaryatra-social-card.png?v=4`; // v4 cache buster

  const seoTitle = title ? `${title} | Antaryatra` : defaultTitle;
  const seoDesc = (description || defaultDesc).substring(0, 160);
  const seoKeywords = keywords || defaultKeywords;
  const seoUrl = url ? (url.startsWith("http") ? url : `${siteUrl}${url}`) : siteUrl;
  
  // Ensure absolute image URL
  let seoImage = ogImage || defaultImage;
  if (seoImage && !seoImage.startsWith("http")) {
    seoImage = `${siteUrl}${seoImage.startsWith("/") ? "" : "/"}${seoImage}`;
  }
  
  const canonicalUrl = canonical || seoUrl;

  return (
    <Helmet>
      {/* Basic HTML Tags */}
      <html lang="en" />
      <title>{seoTitle}</title>
      <meta name="description" content={seoDesc} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:site_name" content="Antaryatra" />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDesc} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Antaryatra" />
      <meta name="twitter:url" content={seoUrl} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDesc} />
      <meta name="twitter:image" content={seoImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

